<template>
    <div v-if="crowds.length">
        <strong>适用人群限制：</strong>
        <span style="color: red">只需添加当前票种可以使用的特殊人群使用限制</span>
        <div v-for="crowd in crowds">
            <div v-if="crowds.length !== 1">
                <b>{{crowd.poiName}}</b>
            </div>
            <div v-for="(model,index) in crowd.ticketDiscountList" class="crowd-item">
                <div>
                    <v-select class="middle-select inline-input" v-model="model.optIndex" placeholder="请选择" @input="getOnSelect(model, crowd.options)" :remote="false">
                        <v-option v-for="(opt,index) in crowd.options" v-if="opt.discountInfo.policyType !== 1" :label="opt.crowdString" :value="index" :key="index">
                        </v-option>
                    </v-select>
                    <span v-if="model.crowd == 1000 && model.crowdString==='其他'">
                         <v-input v-va.tab1="'required|forbidden'" :class="{'input': true, 'is-danger': validateErrors.has('tab1', 'model.otherCrowd', null, index) }" :data-key="index" :forbiddenList="crowd.forbiddenList" class="inline-input" v-model="model.otherCrowd"/>
                    </span>
                    <span>
                         限制为
                         <v-input class="inline-input large-select"  v-model="model.discountInfo.preventCondition" :maxlength="60"></v-input>
                    </span>
                    <span v-if="mode !== 'readonly'">
                        <button class="btn btn-link btn-xs" @click="addItem(crowd.ticketDiscountList)"> <i class="icon-button icon-plus"></i></button>
                        <button class="btn btn-link btn-xs" v-if="model.crowd!==null || model.discountInfo.preventCondition!==null || crowd.ticketDiscountList.length > 1" @click="removeItem(model, index, crowd.ticketDiscountList)"> <i class="icon-button delete icon-cancel"></i></button>
                    </span>
                </div>
                <div v-if="model.freeInfo.policyType === 1">
                    {{model.crowdString}}{{model.freeInfo.preventCondition}}免费
                    <span v-if="extra.isBD" style="margin-left: 5px" class="text-warning">请仔细核对免票信息，如有误，请前往CRM系统中报错</span>
                    <span v-else style="margin-left: 5px" class="text-warning">请仔细核对免票信息，若有误请向您的BD报错</span>
                </div>
                <div style="color: red" v-if="validateErrors.has('tab1','model.otherCrowd', 'required', index)">
                    适用人群不能为空
                </div>
                <div style="color: red" v-else-if="validateErrors.has('tab1','model.otherCrowd', 'forbidden', index)">
                    该人群已存在，请勿重复填写，若有人群限制不同，可修改人群限制内容
                </div>
            </div>
            <!--<div v-if="mode !== 'readonly' && model.servicePhones && model.servicePhones.length > 1" @click="deleteOneServicePhone(index)" class="icon-button delete icon-cancel"></div>-->
        </div>
    </div>
</template>
<style rel="stylesheet/css" lang="postcss" scoped type="text/postcss">
    .crowd-item {
        margin-bottom: 10px;
    }
</style>
<script>
export default {
    data () {
        return {
            optIndex: -1
        }
    },
    props: {
        crowds: {
            type: Array,
            required: true
        },
        extra: {
            type: Object,
            required: true
        },
        mode: {
            type: String,
            required: true
        }
    },
    methods: {
        autoSelectByTicketName (name = '') {

        },
        getOnSelect (model, options) {
            const opt = options[model.optIndex]
            model.crowd = opt.crowd
            model.crowdString = opt.crowdString
            model.otherCrowd = opt.otherCrowd
            model.discountInfo.policyType = opt.discountInfo.policyType
            model.discountInfo.preventCondition = opt.discountInfo.preventCondition
            model.freeInfo.policyType = opt.freeInfo.policyType
            model.freeInfo.preventCondition = opt.freeInfo.preventCondition
        },
        addItem (ticketDiscountList) {
            ticketDiscountList.push({
                crowd: null,
                crowdString: '',
                optIndex: '',
                otherCrowd: null,
                discountInfo: {
                    policyType: null,
                    preventCondition: null,
                },
                freeInfo: {
                    policyType: 0,
                    preventCondition: null
                }
            })
        },
        removeItem (model, index, ticketDiscountList) {
            if (ticketDiscountList.length === 1) {
                model.crowd = null
                model.optIndex = ''
                model.crowdString = ''
                model.otherCrowd = null
                model.discountInfo = {}
                model.freeInfo = {}
                model.discountInfo.policyType = null
                model.discountInfo.preventCondition = null
                model.freeInfo.policyType = 0
                model.freeInfo.preventCondition = null
            } else {
                ticketDiscountList.splice(index, 1)
            }
        }
    },
    mounted: function () {
    },
    watch: {
        crowds: function () {
            if (this.crowds[0].options) {
                for (let crowd of this.crowds) {
                    let crowdString2Index = {}
                    crowd.forbiddenList = []
                    for (let i = 0; i < crowd.options.length; i++) {
                        crowdString2Index[crowd.options[i].crowdString] = i
                        crowd.forbiddenList.push(crowd.options[i].crowdString)
                    }
                    for (let ticketDiscount of crowd.ticketDiscountList) {
                        let index = crowd.forbiddenList.indexOf(ticketDiscount.crowdString)
                        if (index === -1) {
                            index = ''
                        }
                        ticketDiscount.optIndex = index
                    }
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// discountDes.vue?1e9317d8